<template>
  <div class="compose-con">
    <button v-if="this.$route.params.type != 'mailboxes' && isEditCicked" class="toTrash" @click="moveToTrash">
      Trash
    </button>

    <button
      v-if="this.$route.params.type != 'mailboxes' &&
        (
          (this.$route.params.type === 'unread') ||
          (this.$route.params.type === 'inbox') ||
          (this.$route.params.type === 'custom')
        ) && isEditCicked"
      class="move"
      @click="moveClicked"
    >
      Move
    </button>
    <router-link to="/compose-email" v-if="this.$route.params.type != 'mailboxes'&& !isEditCicked" class="compose">
      Compose Email
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    isEditCicked: Boolean
  },
  methods: {
    moveClicked() {
      if(this.$parent.$refs.emailsection.selectedMailboxIDs.length > 0) {
        this.$parent.moveClicked = true;
      }
    },
    moveToTrash() {
      if(this.$parent.$refs.emailsection.selectedMailboxIDs.length > 0) {
        this.$parent.moveToTrash = true;
      }
    }
  }
};
</script>

<style scoped>
.compose-con{
  position: fixed;
  bottom:0;
  right:0;
  background:#f8f8f8;
  padding:10px;
  border-top:1px solid #c2c2c2;
  width:100%;
}
.compose, .toTrash {
  float: right;
  background:#d26d13;
  padding:5px 8px;
  color:#fff;
  border:1px solid #ae5003;
  cursor:pointer;
  border-radius:5px;
  outline:none!important;
}
.move {
  float: left;
  background:#d26d13;
  padding:5px 8px;
  color:#fff;
  border:1px solid #ae5003;
  cursor:pointer;
  border-radius:5px;
  outline:none!important;
  margin-left:20px;
}
.compose:hover, .toTrash:hover, .move:hover {
   background-color: #e56700;
}
</style>
